import React, { useState, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Switch, Route, Link, useRouteMatch, useLocation } from 'react-router-dom';
import { gray, blue, theme } from '../theme';
import { DRAWER_BREAK_POINT } from '../utils';
import CptDataGrid from '../components/cpt-data-grid';
import CptDataGrid2 from '../components/cpt-data-grid2';
import Icd10DataGrid from '../components/icd10-data-grid';
import Icd9DataGrid from '../components/icd9-data-grid';
import TaxonomyDataGrid from '../components/taxonomy-data-grid';

const drawerWidth = window.innerWidth <= DRAWER_BREAK_POINT ? window.innerWidth : 320;

const Search = () => {
  const [isDrawerOpen, toggleDrawer] = useState(true);
  const [isMobileLayout, setMobileLayout] = useState(false);
  const { path } = useRouteMatch();
  const location = useLocation();
  let activeText = 'CPT Codes';
  let activeTab = 'cptCodes';

  const {
    drawerBackground,
    drawerBorderColor,
    drawerTextColor,
    drawerFontSize,
    drawerFontWeight,
    // Drawer Tabs
    tabBackground,
    tabActiveBackground,
    // tabHoverBackground,
    tabIndicatorBackground,
    tabIndicatorHoverBackground,
    tabIndicatorActiveBackground,
    tabTextColor,
    tabHoverTextColor,
    tabActiveTextColor,
    headerBackground,
    headerTextColor,
    groupHeaderTextColor,
    groupHeaderTextOpacity,
    groupHeaderFontSize,
    groupHeaderFontWeight,
    groupTabIndent
    // tabFontSize,
    // tabFontWeight,
    // groupSeparators,
    // headerFontSize,
    // headerFontWeight,
  } = theme.splitPanelDrawer;

  const styles = StyleSheet.create({
    splitPanel: {
      display: 'flex',
      flexFlow: 'row nowrap',
      // position: 'relative',
      background: gray[800],
      height: 'calc(100vh - 45px)',
      width: '100%',
      overflow: 'hidden',
      fontFamily: 'Lato'
    },
    drawer: {
      position: 'relative',
      height: '100%',
      transition: '0.3s',
      padding: '0',
      overflowY: 'auto',
      zIndex: '1900',
      borderRight: `1px solid ${drawerBorderColor}`,
      background: drawerBackground,
      color: drawerTextColor,
      fontSize: drawerFontSize,
      fontWeight: drawerFontWeight
    },
    openDrawer: {
      left: '0',
      minWidth: `${drawerWidth}px`,
      width: `${drawerWidth}px`
    },
    hideDrawer: {
      transition: '0.3s',
      width: '0px',
      minWidth: '0px',
      left: `calc(-1 * ${drawerWidth}px)`
    },
    drawerHeader: {
      height: '40px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      paddingLeft: '8px',
      // cursor: 'pointer',
      background: headerBackground,
      color: headerTextColor,
      borderBottom: `0.5px solid ${drawerBorderColor}`
    },
    drawerHeaderIconContainer: {
      height: '32px',
      width: '32px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '4px',
      cursor: 'pointer'
    },
    drawerHeaderIcon: {
      fontSize: '24px',
      cursor: 'pointer'
    },
    drawerHeaderTextContainer: {
      textAlign: 'left',
      lineHeight: '14px',
      cursor: 'pointer'
    },
    drawerHeaderText: {
      textAlign: 'center',
      fontSize: '18px',
      cursor: 'pointer',
      paddingLeft: '4px'
    },
    drawerHeaderTextSub: {
      fontSize: '14px',
      cursor: 'pointer'
    },
    drawerTabsContainer: {
      height: 'calc(100% - 64px)',
      overflowY: 'auto',
      paddingTop: '8px'
    },
    drawerAccordian: {
      position: 'relative',
      display: 'block',
      transition: '0.5s ease',
      maxHeight: '2000px'
    },
    menuItem: {
      position: 'relative',
      left: '-3px',
      color: gray[300]
    },
    detail: {
      // position: 'relative',
      transition: '0s',
      height: '100%',
      left: '0'
      // display: 'flex',
      // flexFlow: 'column'
    },
    detailHeader: {
      height: '40px',
      background: '#001824',
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'space-between',
      borderBottom: '0.5px solid #082840',
      padding: '0 8px'
    },
    profileBanner: {
      borderBottom: '1px solid transparent'
    },
    profileBannerImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '220px'
    },
    bigUserCardContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid transparent'
    },
    tabs: {
      // borderBottom: '1px solid red'
    },
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0'
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    },
    accordianRightBorder: {
      position: 'absolute',
      width: '1px',
      height: 'calc(100% - 38px)',
      background: '#305C82',
      left: '13px',
      top: '39px'
    },
    linkStyles: {
      display: 'flex',
      alignItems: 'center',
      color: gray[300]
    },
    selectedLink: {
      color: blue[500]
    },
    drawerFile: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '4px',
      color: groupHeaderTextColor,
      opacity: groupHeaderTextOpacity,
      fontSize: groupHeaderFontSize,
      fontWeight: groupHeaderFontWeight,
      height: '40px'
    },
    drawerFileIcon: {
      fontSize: '32px',
      marginRight: '8px'
    },
    activeDrawerMenuItem: {
      borderLeft: `1px solid ${blue[500]}`,
      color: blue[500],
      background: gray[700]
    },
    // New code
    drawerMenuItem: {
      position: 'relative',
      background: tabBackground,
      color: tabTextColor,
      fill: tabTextColor,
      borderLeft: `1px solid ${tabIndicatorBackground}`,
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      paddingLeft: groupTabIndent,
      marginTop: '1px',
      ':hover:not(.activeitem)': {
        // background: tabHoverBackground,
        // color: tabHoverTextColor,
        color: tabActiveTextColor,
        background: tabActiveBackground,
        fill: tabHoverTextColor,
        borderLeft: `1px solid ${tabIndicatorHoverBackground}`
      }
    },
    drawerMenuItemIcon: {
      height: '24px',
      width: '30px',
      minWidth: '24px',
      marginRight: '8px',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px'
    },
    drawerMenuItemActive: {
      borderLeft: `1px solid ${tabIndicatorActiveBackground}`,
      color: tabActiveTextColor,
      background: tabActiveBackground
    },
    drawerMenuItemText: {
      width: '100%',
      fontSize: '1rem',
      lineHeight: '14px'
    }
  });

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const handleWindowResize = () => {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile', isMobile);
    setMobileLayout(window.innerWidth <= 768);
    toggleDrawer(!isMobile);
  };

  const handleOnLinkClick = () => {
    if (isMobileLayout) {
      toggleDrawer(false);
    }
  };

  if (location.pathname.endsWith('/cptcodes2')) {
    activeText = 'CPT Codes';
    activeTab = 'cptCodes2';
  } else if (location.pathname.endsWith('/cptcodes')) {
    activeText = 'CPT Codes';
    activeTab = 'cptCodes';
  } else if (location.pathname.endsWith('/icd9codes')) {
    activeText = 'ICD 9 Codes';
    activeTab = 'icd9Codes';
  } else if (location.pathname.endsWith('/icd10codes')) {
    activeText = 'ICD 10 Codes';
    activeTab = 'icd10Codes';
  } else if (location.pathname.endsWith('/taxonomy')) {
    activeText = 'Taxonomy';
    activeTab = 'taxonomy';
  }

  return (
    <div>
      <div className={css(styles.splitPanel)}>
        {/* Panel Drawer */}
        <div
          className={css(styles.drawer, isDrawerOpen ? styles.openDrawer : styles.hideDrawer)}
        >
          {/* Drawer header */}
          <div className={css(styles.drawerHeader)}>
            {/* Header icon */}
            <div className={css(styles.drawerHeaderIconContainer)}>
              <i className={`fa fa-search ${css(styles.drawerHeaderIcon)}`} />
            </div>
            {/* Header text */}
            <div className={css(styles.drawerHeaderTextContainer)}>
              <div className={css(styles.drawerHeaderText)}>
                Search
              </div>
            </div>
          </div>
          {/* Drawer tabs */}
          <div className={css(styles.drawerTabsContainer)}>
            {/* Data */}
            <div className={css(styles.drawerAccordian)}>
              <div className={css(styles.drawerFile)}>
                <div>
                  Data
                </div>
              </div>
              {/* CPT Codes */}
              <Link
                to={`${path}/cptcodes`}
                onClick={handleOnLinkClick}
              >
                <div
                  className={`noselect ${activeTab === 'cptCodes' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'cptCodes' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    CPT Codes
                  </div>
                </div>
              </Link>
              {/* CPT Codes 2 */}
              <Link
                to={`${path}/cptcodes2`}
                onClick={handleOnLinkClick}
              >
                <div
                  className={`noselect ${activeTab === 'cptCodes2' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'cptCodes2' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    CPT Codes (New)
                  </div>
                </div>
              </Link>
              {/* ICD 9 Codes */}
              <Link
                to={`${path}/icd9codes`}
                onClick={handleOnLinkClick}
              >
                <div
                  className={`noselect ${activeTab === 'icd9Codes' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'icd9Codes' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    ICD 9 Codes
                  </div>
                </div>
              </Link>
              {/* ICD 10 Codes */}
              <Link
                to={`${path}/icd10codes`}
                onClick={handleOnLinkClick}
              >
                <div
                  className={`noselect ${activeTab === 'icd10Codes' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'icd10Codes' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    ICD 10 Codes
                  </div>
                </div>
              </Link>
              {/* Taxonomy */}
              <Link
                to={`${path}/taxonomy`}
                onClick={handleOnLinkClick}
              >
                <div
                  className={`noselect ${activeTab === 'taxonomy' ? 'activeitem' : ''} ${css(styles.drawerMenuItem, activeTab === 'taxonomy' && styles.drawerMenuItemActive)}`}
                >
                  <div className={css(styles.drawerMenuItemText)}>
                    Taxonomy
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        {/* Panel details */}
        <div
          className={css(styles.detail)}
          style={{
            width: isDrawerOpen ? `calc(100vw - ${drawerWidth}px)` : '100vw'
          }}
        >
          <div className={css(styles.detailHeader)}>
            <div
              onClick={() => toggleDrawer(!isDrawerOpen)}
            >
              <i
                className={`mr-2 fa ${isDrawerOpen ? 'fa-chevron-circle-left' : 'fa-chevron-circle-right'}`}
                style={{ fontSize: '24px' }}
              />
            </div>
            <div>{activeText}</div>
          </div>
          {/* Active component */}
          <Switch>
            <Route exact path={`${path}`}>
              {/* <Placeholder text='CPT Codes' /> */}
              <CptDataGrid />
            </Route>
            <Route path={`${path}/cptcodes`}>
              {/* <Placeholder text='CPT Codes' /> */}
              <CptDataGrid />
            </Route>
            <Route path={`${path}/cptcodes2`}>
              {/* <Placeholder text='CPT Codes' /> */}
              <CptDataGrid2 />
            </Route>
            <Route path={`${path}/icd9codes`}>
              {/* <Placeholder text='ICD 9 Codes' /> */}
              <Icd9DataGrid />
            </Route>
            <Route path={`${path}/icd10codes`}>
              <Icd10DataGrid />
            </Route>
            <Route path={`${path}/taxonomy`}>
              <TaxonomyDataGrid
                isDrawerOpen={isDrawerOpen}
              />
            </Route>
        </Switch>
        </div>
      </div>
    </div>
  );
};

export default Search;
